<template>
  <DashboardBottomCardContent
    :callToActionButtonText="$t('L_see_where_you_stand')"
    @callToActionCallback="goToCalculator"
  >
    <template #icon>
      <v-img
        class="ma-0"
        :src="savingsIcon"
        width="65"
        max-width="65"
        alt="savings-icon"
        role="presentation"
      />
    </template>
    <template #content>
      <h4 role="heading" aria-level="3" class="ml-6">
        <span class="text-h4 d-block font-weight-bold">{{ $t('L_pay_yourself_first') }}</span>
        <span class="d-block font-weight-regular">{{ $t('L_not_what_you_earn') }}</span>
      </h4>
    </template>
  </DashboardBottomCardContent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';
import { useGlobalStore } from '@/stores/global/global.store';
import savingsIcon from '../assets/savings-icon.svg';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import { mapStores } from 'pinia';
import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import { $t } from '@/i18n/i18n.ts';
import { RouteNames } from '@/router/routeNames.ts';

export default defineComponent({
  name: 'NoInvestmentsBottom',
  data() {
    return { savingsIcon };
  },
  components: { DashboardBottomCardContent },
  computed: {
    ...mapStores(useGlobalStore),
    calculatorEnabled() {
      return this.globalStore.containsFeature(FEATURE_FLAGS.RETIREMENT_CALCULATOR);
    },
  },
  methods: {
    $t,
    async goToCalculator(this: { $route: RouteLocationNormalizedLoaded; $router: Router }) {
      await this.$router.push({ name: RouteNames.INVESTMENT_CALCULATOR });
    },
  },
});
</script>
